import { Component, OnInit } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "../../../environments/environment";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "app-music-list",
  templateUrl: "./music-list.component.html",
  styleUrls: ["./music-list.component.css"],
})
export class MusicListComponent implements OnInit {
  homeData: any = [];
  app_constant: any;
  shimarStatus = true;
  subcategory = [];
  apiParam = {
    slug: "",
    limit: 20,
    offset: 0,
    partner_id: "",
    feature: false,
    banner: false,
  };
  loadMore: boolean;
  load = false;
  count: any;
  type: any
  constructor(
    private service: BaseService,
    private route: ActivatedRoute,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.app_constant = environment;
    this.route.queryParamMap.subscribe((params: any) => {
      if (params.params.partnar_id) {
        this.apiParam.partner_id = params.params.partnar_id;
        this.getData();
      } else if (params.params.type) {
        this.type = params.params.type
        this.getpodcastData()
      } else {
        this.apiParam.partner_id = "";
        this.getData();
      }
    });

  }
  getData() {
    this.route.params.subscribe((params) => {
      if (params["slug"]) {
        this.apiParam.slug = params["slug"];
      }
    });
    this.service.musicCategoriesData(this.apiParam).subscribe((data: any) => {
      this.homeData = data;
      if (data.content.length > 0) {
        this.subcategory = this.subcategory.concat(data.content);
        this.loadMore = false;
        this.shimarStatus = false;
      } else {
        this.loadMore = false;
        this.shimarStatus = false;
      }
    });
  }
  getpodcastData() {
    this.route.params.subscribe((params) => {
      if (params["slug"]) {
        this.apiParam.slug = params["slug"];
      }
    });
    this.service.homeService(this.apiParam).subscribe((data: any) => {
      this.homeData = data;
      if (data.content.length > 0) {
        this.subcategory = this.subcategory.concat(data.content);
        this.loadMore = false;
        this.shimarStatus = false;
      } else {
        this.loadMore = false;
        this.shimarStatus = false;
      }
    });
  }
  onScroll() {
    const offset = this.apiParam.limit + this.apiParam.offset;
    if (this.homeData?.content?.length > 0) {
      this.loadMore = true;
      this.apiParam.offset = this.apiParam.limit + this.apiParam.offset;
      if (this.type == 'podcast') {
        this.getpodcastData()
      } else {
        this.getData();

      }
    }
  }
}
